import { render, staticRenderFns } from "./MonthlyReportPreviewModal.vue?vue&type=template&id=6153b8a1&"
import script from "./MonthlyReportPreviewModal.vue?vue&type=script&lang=js&"
export * from "./MonthlyReportPreviewModal.vue?vue&type=script&lang=js&"
import style0 from "./MonthlyReportPreviewModal.vue?vue&type=style&index=0&id=6153b8a1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QCardActions,QBtn,QInnerLoading,QSpinnerTail} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QCardActions,QBtn,QInnerLoading,QSpinnerTail})
